import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AggregatorService } from './api/aggregator.service';
import { ExternalServicesService } from './api/externalServices.service';
import { ProcessingPartnerService } from './api/processingPartner.service';
import { SenderIdReportService } from './api/senderIdReport.service';
import { SenderIdRequestService } from './api/senderIdRequest.service';
import { ShortCodeService } from './api/shortCode.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AggregatorService,
    ExternalServicesService,
    ProcessingPartnerService,
    SenderIdReportService,
    SenderIdRequestService,
    ShortCodeService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
